import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupportChatState } from './support-chat.state';

const selectSupportChatState = createFeatureSelector<SupportChatState>('supportChat');

export const selectForeignersSupportChats = createSelector(
  selectSupportChatState,
  state => state.foreignersSupportChats
);
export const selectEmployersSupportChats = createSelector(selectSupportChatState, state => state.employersSupportChats);
export const selectPagination = createSelector(selectSupportChatState, state => state.pagination);

export const selectUnreadCount = createSelector(selectSupportChatState, state => state.unreadCount);
export const selectUnreadCountForeigners = createSelector(selectSupportChatState, state => state.unreadCountForeigners);
export const selectUnreadCountEmployers = createSelector(selectSupportChatState, state => state.unreadCountEmployers);
export const selectUnreadMessagesCount = createSelector(
  selectSupportChatState,
  state => state.openSupportChat.unreadMessagesCount
);

export const selectLoadingSupportChats = createSelector(selectSupportChatState, state => state.loadingSupportChats);
export const selectLoadingMoreSupportChats = createSelector(
  selectSupportChatState,
  state => state.loadingMoreSupportChats
);
export const selectLoadingTranscriptionSupportChat = createSelector(
  selectSupportChatState,
  state => state.loadingTranscriptionSupportChat
);

export const selectErrorMessage = createSelector(selectSupportChatState, state => state.errorMessage);

export const selectOpenSupportChat = createSelector(selectSupportChatState, state => state.openSupportChat);
export const selectLoadingOpenSupportChat = createSelector(
  selectSupportChatState,
  state => state.loadingOpenSupportChat
);

export const selectLoadingSupportChatUpdate = createSelector(
  selectSupportChatState,
  state => state.loadingSupportChatUpdate
);

export const selectIsMinimized = createSelector(selectSupportChatState, state => state.openSupportChat?.isMinimized);
